/**
 * @file ClientForm.tsx
 * @description Form component for creating and editing clients.
 */

import React, { useState, useEffect } from "react";
import { Client } from "../../types";

interface ClientFormProps {
  client?: Client | null;
  onSubmit: (name: string) => void;
  onCancel: () => void;
  isInline?: boolean;
}

const ClientForm: React.FC<ClientFormProps> = ({
  client,
  onSubmit,
  onCancel,
  isInline = false,
}) => {
  const [name, setName] = useState(client?.name || "");

  useEffect(() => {
    if (client) {
      setName(client.name);
    }
  }, [client]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim()) {
      onSubmit(name.trim());
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`p-6 border rounded-lg border-gray-line bg-base-100 ${isInline ? "" : "mb-6"}`}
    >
      <h4 className="!text-2xl !font-medium text-primary mb-4 text-left">
        {client ? "Modifica cliente" : "Nuovo cliente"}
      </h4>
      <div className="flex flex-col gap-4">
        <div>
          <label htmlFor="client-name" className="block mb-2 text-sm font-medium text-left">
            Nome cliente
          </label>
          <input
            id="client-name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full input input-bordered"
            placeholder="Inserisci il nome del cliente"
            required
            autoFocus
          />
        </div>
        <div className="flex gap-2 justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="px-6 rounded-full btn btn-outline"
          >
            Annulla
          </button>
          <button
            type="submit"
            className="px-6 rounded-full btn btn-primary"
            disabled={!name.trim()}
          >
            {client ? "Salva" : "Crea"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default ClientForm;
